import React, { useRef } from 'react';

import percentage from 'Utils/percentage';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);
function CountryProfile({ productTypesMetrics, productTypesTotal }) {
    console.log("Apparel values:")
    console.log(productTypesMetrics.Apparel)

    const chartRef = useRef(null);
    const percentages = {
        APPAREL: productTypesTotal ? percentage(
            productTypesMetrics.Apparel,
            productTypesTotal
        ) : 0,
        FOOTWEAR: productTypesTotal ? percentage(
            productTypesMetrics.Footwear,
            productTypesTotal
        ) : 0,
        EQUIPMENT: productTypesTotal ? percentage(
            productTypesMetrics.Equipment,
            productTypesTotal
        ) : 0,
    };
    const data = {
        labels: ['', '', ''],
        datasets: [
            {
                data: [
                    productTypesMetrics.APPAREL,
                    productTypesMetrics.EQUIPMENT,
                    productTypesMetrics.FOOTWEAR,
                ],
                backgroundColor: ['rgb(255,158,81)', '#FFFFFF', '#999'],
                borderColor: ['#777', '#777', '#777'],
                borderWidth: 1,
            },
        ],
    };

    const defaultData = [
        {
            y: productTypesMetrics.APPAREL,
            color: 'rgb(255,158,81)',
            drilldown: {
                name: '',
                data: [productTypesMetrics.APPAREL],
                color: '#000000',
            },
        },
        {
            y: productTypesMetrics.EQUIPMENT,
            color: '#FFFFFF',
            drilldown: {
                name: '',
                data: [productTypesMetrics.EQUIPMENT],
                color: '#000000',
            },
        },
        {
            y: productTypesMetrics.FOOTWEAR,
            color: '#999',
            drilldown: {
                name: '',
                data: [productTypesMetrics.FOOTWEAR],
                color: '#000000',
            },
        },
    ];
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: 0,
        },
        elements: {
            arc: {
                borderWidth: 2,
                borderColor: '#333', // Add a border for a 3D-like effect
            },
        },
        cutout: '40%', // Converts the pie chart into a donut chart
        hover: {
            mode: 'nearest', // Highlight the nearest segment
            onHover: (event, chartElement) => {
                const chart = chartRef.current; // Use the chartRef to access the chart instance
                if (chart && chartElement.length) {
                    const index = chartElement[0].index; // Get the hovered segment index
                    chart.data.datasets[0].backgroundColor = chart.data.datasets[0].backgroundColor.map((color, i) =>
                        i === index ? color : 'rgba(200, 200, 200, 0.5)' // Lighten other segments
                    );
                    chart.update();
                } else if (chart) {
                    chart.data.datasets[0].backgroundColor = ['rgb(255,158,81)', '#FFFFFF', '#999']; // Reset colors
                    chart.update();
                }
            },
        },
    };
    return (
        <div className="profile">
            <h3>Type of product made</h3>

            <ul className="manufacture-profile">
                <li>
                    Apparel{' '}
                    <span className="total">{productTypesMetrics.APPAREL}</span>
                    <span className="key-color apparel" />
                </li>
                <li>
                    Equipment{' '}
                    <span className="total">
                        {productTypesMetrics.EQUIPMENT}
                    </span>
                    <span className="key-color equipment" />
                </li>
                <li>
                    Footwear{' '}
                    <span className="total">
                        {productTypesMetrics.FOOTWEAR}
                    </span>
                    <span className="key-color footwear" />
                </li>
                <li id="country_piechart">
                <div
                        className="chartContainer"
                        style={
                            {
                            position: 'relative',
                            width: 70,
                            height: 80,
                            marginLeft: '10px',
                            marginTop: '5px'

                        }}
                    >
                        <Pie ref={chartRef} data={data} options={options} />
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default CountryProfile;
